/**
 * Shared page metadata for static landing pages.
 * Used by both route head() functions and the OG image generator
 * to keep titles and descriptions in sync.
 */
import { HOME_HERO_SUBHEAD, HOME_META_TITLE } from "@/landing/lib/home-copy";

export const PAGE_META = {
  "/": { title: HOME_META_TITLE, description: HOME_HERO_SUBHEAD },
  "/pricing": {
    title: "Pricing: Wonda",
    description:
      "One plan, $49.99 a month: your agent on LinkedIn, Sales Navigator, X and Reddit. AI generation billed per use at cost, no credits included.",
  },
  "/models": {
    title: "Model pricing: Wonda",
    description:
      "Image, video and audio models for your agent, billed per use at cost with no markup.",
  },
  "/docs": {
    title: "Documentation: Wonda",
    description:
      "How to install Wonda, sign in to your accounts and have your agent work LinkedIn, Sales Navigator, X and Reddit.",
  },
  "/terms": {
    title: "Terms & Conditions: Wonda",
    description:
      "Terms and Conditions for using the Wonda platform and services.",
  },
  "/privacy": {
    title: "Privacy Policy: Wonda",
    description:
      "Privacy Policy for the Wonda platform: how we handle your personal data.",
  },
  "/acceptable-use": {
    title: "Acceptable Use Policy: Wonda",
    description: "Acceptable Use Policy for the Wonda platform and services.",
  },
  "/affiliates": {
    title: "Affiliate Program: Wonda",
    description:
      "Earn 30% of every payment your referrals make in their first 12 months. Apply in one short form.",
  },
} as const satisfies Record<string, { title: string; description: string }>;
